var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',_vm._b({staticClass:"img",attrs:{"src":_vm.formatSrc,"fit":_vm.fit},on:{"click":_vm.click}},'el-image',_vm.$attrs,false),[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }